import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import { Preferences } from '@capacitor/preferences';
import { UserPhoto } from '@shared/services/photo/model/photo.model';
import { PhotoService } from '@shared/services/photo/photo.service';
import {
  FILE_ERRORS,
  PHOTO_OPTIONS,
} from '@shared/services/file/model/file.model';

@Component({
  selector: 'app-upload-recipe-image-modal',
  templateUrl: './upload-recipe-image-modal.component.html',
  styleUrls: [
    './upload-recipe-image-modal.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class UploadRecipeImageModalComponent implements OnInit {
  @Input() platform: PlatformEnum;

  @Input() recipeId;
  @Input() currentSRC;
  @Output() dismissEvent = new EventEmitter<void>();
  @Output() submitEvent = new EventEmitter<Map<string, string>>();

  acceptedFileTypes = PHOTO_OPTIONS;
  platformRef = PlatformEnum;
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  base64Image: string | null = null;
  uploadError: string | null = null;
  isLoading = false;

  private readonly CACHE_KEY_PREFIX = 'recipe_image_';
  cachedLibraryPhoto: UserPhoto | null = null;
  private get cacheKey() {
    return `${this.CACHE_KEY_PREFIX}${this.recipeId}`;
  }
  cachedPhoto: UserPhoto | null = null;

  constructor(
    readonly platformService: PlatformService,
    private photoService: PhotoService,
    private popoverController: PopoverController,
  ) {}

  dismiss() {
    this.dismissEvent.emit();
  }

  async ngOnInit() {
    this.selectedFile = null;
    this.imagePreview = null;
    this.base64Image = null;
    this.uploadError = null;
    this.cachedPhoto = null;
  }

  async takePhoto() {
    this.isLoading = true;
    try {
      this.uploadError = null;
      const photo = await this.photoService.addPhoto(false);

      this.imagePreview = photo.webviewPath;
      this.base64Image = photo.base64;
      this.cachedPhoto = photo;

      const fileExtension = photo.extension || 'jpeg';
      this.selectedFile = this.photoService.getFileFromBase64(
        photo.base64,
        fileExtension,
      );

      this.isLoading = false;
    } catch (error) {
      this.imagePreview = null;
      if (error.message === FILE_ERRORS.wrongSize) {
        this.uploadError =
          'i18n.menuProfitPro.uploadRecipeImageModal.modalErrors.fileSizeExceeded';
      } else if (error.message === FILE_ERRORS.wrongMime) {
        this.uploadError =
          'i18n.menuProfitPro.uploadRecipeImageModal.modalErrors.wrongImageType';
      } else if (error.message === 'Picker was abandoned') {
        this.uploadError = null;
      } else {
        this.uploadError = error.message;
      }
      this.isLoading = false;
    }
  }

  async saveAndSendToS3(): Promise<void> {
    const updates = new Map<string, string>();
    const fileExtension = this.selectedFile.name.split('.').pop() || 'png';
    updates.set('fileName', this.selectedFile.name);
    updates.set('extension', fileExtension);
    updates.set('value', this.base64Image);
    this.submitEvent.emit(updates);
  }
  closePopover = async () => {
    if (this.popoverController.getTop()) {
      await this.popoverController.dismiss();
    }
  };

  closePopoverOnBlur() {
    window.addEventListener('blur', this.closePopover, { once: true });
  }

  removeWindowListener = () => {
    window.removeEventListener('blur', this.closePopover);
  };
}
